import BaseModelAPI from '../BaseModelAPI';

export default class UserInfo extends BaseModelAPI {
  static entity = 'user_infos'
  static entityName = "core-users";
  
  constructor () {
    return {
      id : '',
      userName : '',
      name : '',
      lastName : '',
    }
  }
}